package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class BulkCreatePlayerResponse(
    val concurrency: Long,
    val created: Long,
    val details: List<BulkCreatePlayerDetail>,
    val dryRun: Boolean,
    val durationSec: Double,
    val errors: Long,
    val sendEmails: Boolean,
    val skipped: Long,
    val source: String,
    val totalRows: Long,
    val error: String? = null,

)
@Serializable
data class BulkCreatePlayerDetail(
    val email: String,
    val line: Long,
    val reason: String,
    val status: String,
)